// extracted by mini-css-extract-plugin
export default {"title":"InfoLocation_title__orQ23","container":"InfoLocation_container__tUJY1","flex":"InfoLocation_flex__HMSK6","link":"InfoLocation_link__T1kDz"};